// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingIndicator_wrapper__1E5sw","loaderContainer":"LoadingIndicator_loaderContainer__aL8NX"};